import * as React from 'react';
export const StyledComponentsIcon = (props) => {
    return (
        <img
            {...props}
            alt="styled-components-logo"
            src="https://file.rendit.io/n/7cYAOZzVortdigDULqRO.png"
            className="min-w relative w-4"
        />
    );
};
